import featureWatchHistoryConfig from './feature/watchHistory'

const watchHistoryConfig = {
  COMPLETED_THRESHOLD: featureWatchHistoryConfig.completedThreshold,
  NO_DURATION_PERCENT_COMPLETED: featureWatchHistoryConfig.noDurationPercentCompleted,
}

const continueWatchingConfig = {
  batchSize: featureWatchHistoryConfig.continueWatching.batchSize,
}

export { watchHistoryConfig, continueWatchingConfig }
